import { needsRequests } from './needs'
import { residentsRequests } from './residents'
import { usersRequests } from './users'
import { goalsRequests } from './goals'

const requests = {
  residents: residentsRequests,
  needs: needsRequests,
  users: usersRequests,
  goals: goalsRequests,
}

export default requests
